import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { BadgeIcon } from './badge-icon';
import { assembleName } from './util';
import { getProviderBadgeLabel, getProviderTypeIcon } from './provider-badge.util';

export interface IProviderIdBadgeProps {
    className?: string;
    id?: string;
    first?: string;
    suffix?: string;
    last?: string;
    organization?: string;
    npi?: string;
    type?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const ProviderBadge: React.FunctionComponent<IProviderIdBadgeProps> = (
    props: IProviderIdBadgeProps,
): React.ReactElement => {
    const { className, id, first, suffix, last, organization, npi, type, tooltip, items } = props;
    const name = assembleName(first, last, suffix);
    const label = getProviderBadgeLabel(type, id, name, organization, npi);

    return (
        <ActionMenuBadge
            className={className}
            label={label}
            tooltip={tooltip || label}
            items={items}
            id={id}
            Symbol={<BadgeIcon path={getProviderTypeIcon(type)} />}
        />
    );
};
